import { useQuery } from '@tanstack/react-query';
import { fetchFundDisbursements } from '../../api/finance/fundDisbursements';

export const useFundDisbursements = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['fundDisbursements', filters],
    queryFn: () => fetchFundDisbursements(filters),
    keepPreviousData: true,
    enabled: options.enabled,
  });

  return {
    ...query,
    data: query.data?.data?.fundDisbursements ?? [],
    pagination: query.data?.data?.pagination ?? {
      currentPage: 1,
      pageSize: filters?.pageSize ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };
};

export default useFundDisbursements;
